import api from './axios';

const BASE = '/api-keys';

export const generateApiKey = () => api.post(`${BASE}/generate`);

export const getCurrentApiKey = () => api.get(`${BASE}/current`);

export const revokeApiKey = () => api.delete(`${BASE}/current`);
